import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { dataFetched, makesSubscriptions } from 'data/graphql'
import { selectors as OrganizationSelectors } from 'data/organizations'

const onApplicationInstalledQuery = gql`
  subscription applicationInstalled($organizationId: ID!) {
    applicationInstalled(organizationId: $organizationId) {
      __typename
      id
      isInstalled
      name
      photoURL
      name
      clientId
      features
      labels {
        shareToAction
        shareToActionVerb
        shareToSuccess
        shareToSuccessLinkLabel
        userConnectIncentive
      }
      integration {
        __typename
        id
        unfurlPatterns
      }
    }
  }
`

const onApplicationRemovedQuery = gql`
  subscription applicationRevoked($organizationId: ID!) {
    applicationRevoked(organizationId: $organizationId) {
      __typename
      id
      isInstalled
      name
      photoURL
      name
      clientId
      features
      labels {
        shareToAction
        shareToActionVerb
        shareToSuccess
        shareToSuccessLinkLabel
        userConnectIncentive
      }
      integration {
        __typename
        id
      }
    }
  }
`

const providesApplicationsSubscriptions = compose(
  connect(
    state => ({
      organizationId: OrganizationSelectors.getOrganizationId(state),
    }),
    { dataFetched }
  ),

  makesSubscriptions({
    query: onApplicationInstalledQuery,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      const application = result.data.applicationInstalled

      dataFetched(application, meta)
    },
  }),

  makesSubscriptions({
    query: onApplicationRemovedQuery,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      const application = result.data.applicationRevoked
      dataFetched(application, meta)
    },
  })
)

export default providesApplicationsSubscriptions
